import styled from 'styled-components'
import EtcSelectPanelUpdateIcon from './UpdateIcon'

interface PropsType {
  url: string
}

const SearchLink = styled.a`
  align-items: center;
  background-color: #fff;
  border: 1px solid #999;
  color: #000;
  display: flex;
  font-size: 14px;
  font-weight: bold;
  height: 40px;
  justify-content: center;
  min-width: 120px;
  text-align: center;
  width: 100%;

  &:visited {
    color: #000;
  }

  &:hover {
    background-color: #f2f8ff;
    color: #457ab5;
    text-decoration: none;
  }

  &:active {
    color: #dae5f2;
  }
`

const UpdateButton = (props: PropsType) => {
  return (
    <SearchLink href={props.url}>
      その他条件を更新
      <EtcSelectPanelUpdateIcon />
    </SearchLink>
  )
}

export default UpdateButton
